// extracted by mini-css-extract-plugin
export default {"Dropdown-menu":"NewBanner_Dropdown-menu__+F33q","banner":"NewBanner_banner__7JXW+"};